import { masterClient } from '~/core/utils/clients/masterClient'

const RESOURCE = '/analytics'

export default {
  sendReferralId(id: number) {
    return masterClient.post(`${RESOURCE}/referral/metric/${id}/`, {}, { camelize: true })
  },
  sendOpenMt() {
    return masterClient.post(`${RESOURCE}/open_mt/`, {}, { camelize: true })
  },
}
